var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`fygr-icon-button bg-${_vm.background} clr-${_vm.color} hov-${_vm.hover}`,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{class:`fi-${_vm.icon}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }